import { MBase } from "./MBase";
import * as moment from 'moment';

export class Setor extends MBase {
  EmpresaId: number;
  FazendaId: number;
  Descricao:string = "";
  Irrigado: boolean;
  Sequeiro: boolean;
  Ativo: boolean = true;
  UsuarioAlteracaoDesc: string;

  get descAtivo(): string{
    return this.Ativo ? 'Ativo' : 'Inativo'
  }

  get dataAlteracaoStr(): string{
    return moment(this.DataAlteracao).format('DD/MM/YYYY HH:mm')
  }
}
